export const LogoMark = ({ className = "h-10 w-auto", alt = "Ascencio Auto Repair — official logo", testId }) => (
  <img src="/logo.png" alt={alt} className={className} draggable="false" data-testid={testId} />
);
